import React from 'react';
import { Card, CardBody, CardTitle, Input, Label, FormGroup, FormFeedback } from 'reactstrap';
import HelpIcon from '../search-components/HelpIcon';
import ResetFormComponentDefaults from './ResetFormComponent';

const help = {
  word: {
    name: 'Įrašykite ieškomą žodį. Galite čia nieko nerašyti, bet tada pasirinkite kitus paieškos parametrus.',
    value: 'word',
  },
  lema: {
    name: 'Jei eilutėje „žodis“ įrašysite ieškomą žodį ir pažymėsite lemą (antraštinę formą), gausite junginius, kur ieškomas žodis vartojamas įvairiomis kaitybinėmis formomis.',
    value: 'lema',
  },
  exact: {
    name: 'Jei eilutėje „žodis“ įrašysite ieškomą žodį ir pažymėsite „tiksli forma“, gausite junginius, kur ieškomas žodis vartojamas būtent ta kaitybine forma.',
    value: 'exact',
  },
  pos: {
    name: 'Tiek įrašius žodį, tiek jo neįrašius, galima pasirinkti iš nurodytų kalbos dalių.',
    value: 'pos',
  },
  position: {
    name: 'Ieškant žodžio arba kalbos dalies, galima nurodyti vietą žodžių junginyje: kad būtų vartojamas kaip pirmas, antras arba trečias žodžių junginio dėmuo (galimi ir kitokie deriniai).',
    value: 'position',
  },
  main: {
    name: 'Pažymėkite šį laukelį, jei norite, kad ieškomas žodis arba kalbos dalis būtų sintaksiškai pagrindinis žodžių junginio dėmuo.',
    value: 'main',
  },
};

class AdvancedWordInput extends React.Component {
  validateWord(e) {
    const wordsRex = /^\s*([\wąčęėįšųūžĄČĘĖĮŠŲŪŽ]+\s*)?$/;
    const wordValid = wordsRex.test(e.target.value);
    this.props.setValidation(wordValid);
  }

  render() {
    const type = this.props.word.type;

    return (
      <Card className="p-2 m-2">
        <CardBody>
          <CardTitle>Žodis</CardTitle>
        </CardBody>

        <FormGroup>
          <Label for={"word" + type}>
            Žodis <HelpIcon text={help.word.name} value={help.word.value + type}/>
          </Label>
          <Input type="text" value={this.props.word.word}
                 onChange={(e) => {
                   this.validateWord(e);
                   this.props.onInputChange(e);
                 }}
                 name="word" id={"word" + type}
                 invalid={!this.props.wordValid}
          />
          <FormFeedback>
            Įvesti galite tik vieną žodį
          </FormFeedback>
        </FormGroup>

        <div>
          <FormGroup check inline>
            <Label check>
              <Input name="lema" type="checkbox" checked={this.props.word.lema}
                     onChange={this.props.onLemaFormChange}/>{' '}
              Lema <HelpIcon text={help.lema.name} value={help.lema.value + type}/>
            </Label>
          </FormGroup>

          <FormGroup check inline>
            <Label check>
              <Input name="exact" type="checkbox" checked={this.props.word.exact}
                     onChange={this.props.onLemaFormChange}/>{' '}
              Tiksli forma <HelpIcon text={help.exact.name} value={help.exact.value + type}/>
            </Label>
          </FormGroup>
        </div>


        <FormGroup className="mt-3">
          <Label for={"pos" + type}>
            Kalbos dalis <HelpIcon text={help.pos.name} value={help.pos.value + type}/>
          </Label>
          <Input type="select" name="pos" id={"pos" + type} value={this.props.word.pos}
                 onChange={this.props.onInputChange}>
            {this.props.posSelect.map((kw) =>
              <option value={kw.value} key={kw.value}>{kw.name}</option>
            )}
          </Input>
        </FormGroup>

        <FormGroup check>
          <Label check>
            <Input name="main" type="checkbox" checked={this.props.word.main}
                   onChange={this.props.onMainChange}/>{' '}
            Pagrindinis dėmuo <HelpIcon text={help.main.name} value={help.main.value + type}/>
          </Label>
        </FormGroup>

        <FormGroup className="mt-3">
          <Label for={"position" + type}>
            Vieta junginyje <HelpIcon text={help.position.name}
                                      value={help.position.value + type}/></Label>
          <div id={"position" + type}>
            <FormGroup check inline>
              <Label check>
                <Input type="checkbox" name="w1" checked={this.props.word.w1} onChange={this.props.onInputChange}/> 1
              </Label>
            </FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input type="checkbox" name="w2" checked={this.props.word.w2} onChange={this.props.onInputChange}/> 2
              </Label>
            </FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input type="checkbox" name="w3" checked={this.props.word.w3}
                       disabled={this.props.wc2} onChange={this.props.onInputChange}/> 3
              </Label>
            </FormGroup>
          </div>
        </FormGroup>

        <ResetFormComponentDefaults resetDefaults={this.props.resetDefaults} value={type}/>
      </Card>
    );
  }
}

export default AdvancedWordInput;

